export default __webpack_public_path__ + "atomic/_patterns/01-atoms/form-element/_input.twig";